<template>
  <section v-if="hasPermissions(['Report Read', 'Report Write'])" class="view">
      <Breadcrumb :breadcrumb="breadcrumb"/>
      <h1 class="view__title title--1" v-html="title_page"/>
      <div class="view__description">
          <p class="view__description__text">
          </p>
      </div>

      <div class="row bar__container">
          <div class="col-4 col-md-2 py-0"/>
          <div class="col-md-auto flex-xl-grow-1" style="padding-top:0px;">
              <div class="modal__buttons text-center text-md-left text-lg-right" style="margin-top:0px;">
                  <div class="btn-group modal__buttons__item w-auto mr-md-auto ml-sm-2 px-3 ml-md-2" style="margin-top:-2px;">
                      <button type="button" style="border-top-right-radius: 0px; border-bottom-right-radius: 0px; padding-right:15px;" v-html="'Export'" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"/>
                      <button type="button" class="dropdown-toggle dropdown-toggle-split ml-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="border-top-left-radius: 0px; border-bottom-left-radius: 0px; padding-right:0px;">
                          <span class="sr-only"/>
                      </button>
                      <div class="dropdown-menu" :style="'font-size: 14px; padding:0; margin-top: 0px;'">
                          <a class="dropdown-item"  v-html="'Export to PDF Portrait'" @click="exportPDF('portrait')"/>
                          <a class="dropdown-item" v-html="'Export to PDF Landscape'" @click="exportPDF('landscape')"/>
                      </div>
                  </div>
                  <button class="modal__buttons__item w-auto ml-1 ml-md-2 px-3" v-html="`Close`" @click="backToReports()" style="margin-right:8px;"/>
              </div>
          </div>
      </div>
      
      <div class="tab-content" v-show="pdfSource">
          <div class="tab-pane fade active show" id="listation">
              <div class="row mb-0 no-gutters justify-content-md-center">
                  <div class="col-lg-10" style="min-height: 60rem">
                      <v-card style="height: 100%">
                        <div >
                          <iframe style="width: 100%; height: 60rem;" :src="pdfSource"></iframe>
                        </div>
                      </v-card>
                  </div>
              </div>
          </div>
      </div>
      <WaitingModal/>
  </section>

  <div v-else>
      <UnauthorizedComponent :breadcrumb="breadcrumb"/>
  </div>

</template>

<script>
import axios        from 'axios';
import Resources    from './resources'
import Breadcrumb   from '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal from '@/components/WaitingModal'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import jsPDF        from 'jspdf'
import 'jspdf-autotable'
import { Notyf }    from 'notyf'
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css' // for React and Vue
// import FormResources from './form_resources';
const notyf = new Notyf({
  duration: 8000,
});

export default {

  name: "BudgetingReport",

  components: {
      Breadcrumb,
      WaitingModal,
      UnauthorizedComponent,
  },

  data() {
      return {
          notyf,
          axios,
          report_root:        {
            name: 'Staffing / Budget Analysis'
          },
          parent_id:            4,
          staffing_scenario_id: this.$route.params.id,
          user:                  this.get_user(),
          title_page:          'Reports',
          rest_api:            `search_standard_reports`,
          title:               'Staffing Budget Report',
          current_url:         `/reports`,
          table_headers:       [],
          breadcrumb:          JSON.parse(JSON.stringify(Resources.breadcrumb)),
          single_select:       false,
          table_selection:     [],
          search:              '',
          array_options:       {},
          report_render:       'all',

          json_excel_fields:   {},
          json_pdf_fields:     Resources.quick_report_supervisor_view,

          company_name:        'Digital Solutions, SE & Associates, Inc.',

          headers_daily_table:          Resources.headers_main_table,
          headers_project_table:        Resources.headers_project_table,
          headers_variable_items_table: Resources.headers_variable_items_table,
          data_group_1:        [],
          data_group_2:        [],
          data_group_3:        [],
          data_group_4:        [],
          variable_items:      [],
          all_totals:          {},
          staffing_scenario:   {},
          logo_corporation:  null,
          groups:              [],
          pdfSource: '',
      };
  },

  methods: {

      backToReports()
      {
          window.location.href = '/reports'
      },
      handleDocumentRender() {
          this.pageCount = this.$refs.pdfRef.pageCount
      },

      addWaterMark(doc, preview)
      {
          const total_pages = doc.internal.getNumberOfPages()
          const printWidth = doc.internal.pageSize.width - (10 + 10);

          for (let i = 1; i <= total_pages; i++)
          {
              doc.setPage(i)

              if(!preview)
              {
                doc.addImage("/assets/img/logo.png", 'png', 40, 28, 120, 40)

                if(this.logo_corporation)
                {
                    doc.addImage(this.logo_corporation.base64, printWidth - this.logo_corporation.width, 10, this.logo_corporation.width, this.logo_corporation.height);
                }
              }
              else
              {
                doc.setFontSize(15);
                doc.text(40,28, `Preview`)
              }

              if(i === 1)
              {
                  doc.setTextColor(70)
                  doc.setFontSize(13);
                  doc.setFont(undefined, 'bold')
                  let xOffsetSubTitle = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(this.staffing_scenario.scenario) * doc.internal.getFontSize() / 2); 
                  doc.text(xOffsetSubTitle, 135, this.staffing_scenario.scenario)

                  doc.setFontSize(10);
                  doc.text(37,160, `Staffing (Start Up)`)

                  doc.setFontSize(9);
                  doc.setDrawColor(0);
                  doc.setFillColor(255, 0, 0);
                  doc.rect(60, 193, 500, 49, 'D');

                  doc.text(73, 207, `Average Wage:`)
                  doc.text(69, 230, `Budgeted FTEs:`)

                  doc.text(229, 207, `Benefits:`)
                  doc.text(229, 230, `NonProd:`)

                  doc.text(370, 207, `Average Annual Salary:`)
                  doc.text(400, 230, `Budgeted Labor:`)

                  doc.setFont(undefined, 'normal')

                  doc.text(155, 207, `$${this.staffing_scenario.average_wage}`, {maxWidth: 70})
                  doc.text(155, 230, `${this.staffing_scenario.budgeted_ftes}`,  {maxWidth: 70})

                  doc.text(280, 207, `${this.staffing_scenario.benefits}%`, {maxWidth: 86})
                  doc.text(280, 230, `${this.staffing_scenario.nonproductive}%`, {maxWidth: 86})

                  doc.text(478, 207, `$${this.staffing_scenario.av_annual_salary}`, {maxWidth: 82})
                  doc.text(478, 230, `$${this.staffing_scenario.budgeted_labor}`, {maxWidth: 82})


                  doc.setFontSize(10);
                  doc.setFont(undefined, 'normal')

              }

              doc.setTextColor(150)
              doc.setFontSize(9);
              doc.text(40, doc.internal.pageSize.height - 30, this.report_root.name)
              doc.text(doc.internal.pageSize.width - 80, doc.internal.pageSize.height - 30, `${i} of ${total_pages}`)

              let xOffset = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(this.company_name) * doc.internal.getFontSize() / 2); 
              doc.text(xOffset, doc.internal.pageSize.height - 30, this.company_name)
          }

          return doc
      },

      exportPDF(orientation, preview = false)
      {   
          let PDF_doc = new jsPDF(orientation , 'pt', 'letter')

        PDF_doc.autoTable(['Staffing / Budget Analysis'], [],{
          startY: 92,
          rowPageBreak: 'avoid',
          styles: {fontSize: 15},
          headStyles:{
              valign: 'middle',
              halign : 'center',
              fillColor : [245, 245, 245],
              textColor: [70, 70, 71],
              fontStyle: 'normal',
          }
      })

          PDF_doc.setFontSize(12)
          PDF_doc.text(40, 278, this.groups.length ? this.groups[0].name : 'Group 1')

          PDF_doc.autoTable(this.headers_daily_table, this.data_group_1, {
              margin: { top: 100 },
              startY: 285,
              showHead: 'firstPage',
              columnStyles: 
              {
                0: {minCellWidth: 200},
                1: {minCellWidth: 80},
                2: {minCellWidth: 70},
                3: {minCellWidth: 80},
                4: {minCellWidth: 70},
              },
              didParseCell: (data) =>
              {
                this.didParseCell(data)
              },
              willDrawCell: (data) => {
                this.willDrawCell(data, PDF_doc)
              },
          })

          let finalY = PDF_doc.lastAutoTable.finalY;
          PDF_doc.text(40, (finalY + 13), this.groups.length ? this.groups[1].name : 'Group 2')

          PDF_doc.autoTable(this.headers_daily_table, this.data_group_2, {
              margin: { top: 100 },
              showHead: 'firstPage',
              columnStyles: 
              {
                0: {minCellWidth: 200},
                1: {minCellWidth: 80},
                2: {minCellWidth: 70},
                3: {minCellWidth: 80},
                4: {minCellWidth: 70},
              },
              didParseCell: (data) =>
              {
                this.didParseCell(data)
              },
              willDrawCell: (data) => {
                this.willDrawCell(data, PDF_doc)
              },
          })

          finalY = PDF_doc.lastAutoTable.finalY;
          PDF_doc.text(40, (finalY + 13), this.groups.length ? this.groups[2].name : 'Group 3')

          PDF_doc.autoTable(this.headers_project_table, this.data_group_3, {
              margin: { top: 100 },
              showHead: 'firstPage',
              columnStyles: 
              {
                0: {minCellWidth: 290},
                2: {minCellWidth: 70},
                3: {minCellWidth: 70},
                4: {minCellWidth: 60},
              },
              didParseCell: (data) =>
              {
                this.didParseCell(data)
              },
              willDrawCell: (data) => {
                this.willDrawCell(data, PDF_doc)
              },
          })

          finalY = PDF_doc.lastAutoTable.finalY;
          PDF_doc.text(40, (finalY + 13), this.groups.length ? this.groups[3].name : 'Group 4')

          PDF_doc.autoTable(this.headers_daily_table, this.data_group_4, {
              margin: { top: 100 },
              showHead: 'firstPage',
              columnStyles: 
              {
                0: {minCellWidth: 200},
                1: {minCellWidth: 80},
                2: {minCellWidth: 70},
                3: {minCellWidth: 80},
                4: {minCellWidth: 70},
              },
              didParseCell: (data) =>
              {
                this.didParseCell(data, true)
              },
              willDrawCell: (data) => {
                this.willDrawCell(data, PDF_doc, true)
              },
          })

          finalY = PDF_doc.lastAutoTable.finalY;
          if( finalY >= PDF_doc.internal.pageSize.height - 90)
          {
            PDF_doc.addPage();
            finalY= 50;
          }
          PDF_doc.text(40, (finalY + 40), 'Variable Items')

          PDF_doc.autoTable(this.headers_variable_items_table, this.variable_items, {
              margin: { top: 100 },
              startY: finalY + 50,
              showHead: 'firstPage',
              didParseCell: (data) =>
              {
                this.didParseCell(data)
              },
              willDrawCell: (data) => {
                this.willDrawCell(data, PDF_doc)
              },
          })

          this.printSummary(PDF_doc);

         
          PDF_doc = this.addWaterMark(PDF_doc, preview)

          if(preview)
          {
            var blobPDF =  new Blob([ PDF_doc.output() ], { type : 'application/pdf'});
            var blobUrl = URL.createObjectURL(blobPDF);  //<--- THE ERROR APPEARS HERE
            this.pdfSource=blobUrl
          }
          else
          {
            PDF_doc.save(`${this.report_root.name}|Staffing-Budget-Analysis.pdf`)
          }
      },

      didParseCell(data, last_table = false){
        var rows = data.table.body;
        let cell_style =  data.cell.styles
        // let compare = last_table ? 3 : 2

        if (data.row.index >= (rows.length - (last_table ? 3 : 2)))
        {
          cell_style.lineWidth = 0;
        }

        if (data.row.index >= (rows.length - (last_table ? 2 : 1)))
        {
          cell_style.fillColor = [255, 255, 255];
          cell_style.fontStyle = 'bold' 
        }

      },
      willDrawCell(data, PDF_doc, last_table = false)
      {
        var rows = data.table.body;
                
        if (data.row.index >= rows.length - (last_table ? 2 : 1)) 
        {
          if(data.cell.raw || data.cell.raw === null)
          {

            PDF_doc.setDrawColor(0, 0, 0); 
            PDF_doc.setLineWidth(2); 
          
            if(last_table && data.row.index === rows.length - 1 && data.cell.raw != 'Fixed Total')
            {
              PDF_doc.line(
                data.cell.x + data.cell.width,
                data.cell.y,
                data.cell.x,
                data.cell.y
              );
            }
            else if(!last_table || data.row.index === rows.length - 2)
            {
              PDF_doc.line(
                data.cell.x + data.cell.width,
                data.cell.y,
                data.cell.x,
                data.cell.y
              );
            }
          }
        }

      },

      printSummary(doc)
      {
        doc.setFontSize(10);
        doc.setDrawColor(0, 0, 0); 
        doc.setLineWidth(1.5); 
        let finalY = doc.lastAutoTable.finalY + 40;
        let xFirstValue = doc.internal.pageSize.width - 110
        let xSecondValue = doc.internal.pageSize.width - 190

        finalY = this.validateYvalue(doc, finalY);

        doc.text(44, finalY, `Fixed & Variable Total:`)
        doc.text(xFirstValue, finalY, this.all_totals.ftes)
        doc.text(xSecondValue, finalY, this.all_totals.annual_hours)

        finalY += 23
        finalY = this.validateYvalue(doc, finalY);

        doc.text(44, finalY, `Breaks:`)
        doc.text(xFirstValue, finalY, this.all_totals.breaks_ftes)
        doc.text(xSecondValue, finalY, this.all_totals.breaks_annual_hours)

        doc.line(
          xFirstValue + 55,
          finalY + 8,
          xSecondValue,
          finalY + 8
          );

        finalY += 23
        finalY = this.validateYvalue(doc, finalY);

        doc.text(44, finalY, `Productive Total:`)
        doc.text(xFirstValue, finalY, this.all_totals.sum_ftes)
        doc.text(xSecondValue, finalY, this.all_totals.sum_annual_hours)

        finalY += 23
        finalY = this.validateYvalue(doc, finalY);

        doc.text(44, finalY, `NonProductive at ${this.staffing_scenario.nonproductive}%:`)
        doc.text(xFirstValue, finalY,  this.all_totals.non_productive_ftes)
        doc.text(xSecondValue, finalY, this.all_totals.non_productive_annual_hours)

        doc.line(
          xFirstValue + 55,
          finalY + 8,
          xSecondValue,
          finalY + 8
          );

        finalY += 23
        finalY = this.validateYvalue(doc, finalY);

        doc.text(44, finalY, `Sub Total:`)
        doc.text(xFirstValue, finalY, this.all_totals.sub_total_ftes)
        doc.text(xSecondValue, finalY, this.all_totals.sub_total_annual_hours)

        finalY += 23
        finalY = this.validateYvalue(doc, finalY);

        doc.text(44, finalY, `Management:`)
        doc.text(xFirstValue, finalY, this.all_totals.management_ftes)
        doc.text(xSecondValue, finalY, this.all_totals.management_annual_hours)

        doc.line(
          xFirstValue + 55,
          finalY + 8,
          xSecondValue,
          finalY + 8
          );

        finalY += 23
        finalY = this.validateYvalue(doc, finalY);

        doc.text(44, finalY, `GRAND TOTAL:`)
        doc.text(xFirstValue, finalY, this.all_totals.grand_total_ftes)
        doc.text(xSecondValue, finalY, this.all_totals.grand_total_annual_hours)


        finalY += 46
        finalY = this.validateYvalue(doc, finalY);

        doc.text(44, finalY, `FTE Variance from budget:`)
        doc.text(xFirstValue, finalY, this.all_totals.variance_from_budget)

        finalY += 23
        finalY = this.validateYvalue(doc, finalY);

        doc.text(44, finalY, `$ Variance from budget:`)
        doc.text(xFirstValue, finalY, this.all_totals.from_budget)

        finalY += 46
        finalY = this.validateYvalue(doc, finalY);

        doc.text(44, finalY, `Notes:`)

        finalY += 20
        finalY = this.validateYvalue(doc, finalY);

        doc.text(44, finalY, this.staffing_scenario.notes, {maxWidth: 530})


      },

      validateYvalue(doc,y)
      {
        if( y >= doc.internal.pageSize.height - 70)
        {
          doc.addPage();
          return 100;
        }

        return y;

      },

      async fill_data(data)
      {
          // this.loader(true)


          this.staffing_scenario = data.staffing_scenario
          
          this.report_root = {
              title: `Staffing Budget Report`,
              name: this.staffing_scenario.scenario,
          }
          this.title_page = this.report_root.name

          this.data_group_1   = data.data_group_1
          this.data_group_2   = data.data_group_2
          this.data_group_3   = data.data_group_3
          this.data_group_4   = data.data_group_4
          this.variable_items = data.variable_items
          this.all_totals     = data.all_totals
          this.groups         = data.groups
          this.logo_corporation = data.logo_corporation

          this.breadcrumb.push(
              {
                  name: this.report_root.title,
                  href: this.current_url,
                  arrow: `<span class='slash'>/</span>`,
              },
          )

          this.breadcrumb.push(
              {
                  name: this.report_root.name,
                  href: this.current_url,
                  arrow: '',
              },
          )

            
          this.exportPDF('portrait', true)
          this.loader() 
          // this.$refs.dinamic_table.refresh_headers()

      },
      
  },

  async mounted()
  {
      if(this.hasPermissions(['Report Read']))
      {
          const form_data = {
              standard_report_id: this.parent_id,
              staffing_scenario_id: this.staffing_scenario_id
          }

          this.loader(true)

          const response = await this.post('search_standard_reports', form_data)

          if(response.status)
          {
              this.fill_data(response.data)
          }
          else
          {
              this.error_handling(response)
              this.loader(false)
          }
      }
  },

}
</script>